import styles from "./IncentivisedBadge.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const IncentivisedBadge = () => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <div className={styles.incentivisedBadgeContainer}>
      <span className="product-incentivised" />
      <p className={styles.incentivisedText}>
        {getTranslation("pdp_ratings_reviews_incentivized_review_badge_text")}
      </p>
    </div>
  );
};

export default IncentivisedBadge;
